import { Post } from '@/types/post'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import { renderOptionFunc, RichTextStyleWrapper } from '@/components/contentful/Shared'

export default function PostBody({ content }: Pick<Post, 'content'>) {
  return (
    <div className="max-w-2xl mx-auto">
      <RichTextStyleWrapper>
        {documentToReactComponents(content?.json, renderOptionFunc(content?.links?.assets))}
      </RichTextStyleWrapper>
    </div>
  )
}
